<template>
  <div class="modal" @keydown.enter="handleEnterKey" @keydown.esc="$emit('close')">
    <div class="modal-content">
      <div class="modal-header">
        <h1>Create event</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('close')"
                aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="submitForm">
          <div class="mb-3">
            <label for="code" class="form-label">Code</label>
            <input type="text" class="form-control" id="code" v-model="code" ref="inputCode" required
                   placeholder="Short event code"/>
            <div v-if="eventCodeError" class="text-danger">{{ eventCodeError }}</div>
          </div>
          <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control" id="name" v-model="name" required placeholder="Full event name"/>
            <div v-if="eventNameError" class="text-danger">{{ eventNameError }}</div>
          </div>
          <div class="mb-3">
            <label for="date" class="form-label">Date</label>
            <input type="date" class="form-control" id="date" v-model="date" required/>
          </div>
          <fieldset class="border p-2">
            <legend class="w-auto px-2">Shift timing</legend>
            <div class="mb-3">
              <label for="default_shift_start_time" class="form-label">Default start time</label>
              <input type="time" class="form-control" id="default_shift_start_time"
                     v-model="default_shift_start_time" required>
            </div>
            <div class="mb-3">
              <label for="default_shift_duration" class="form-label">Default duration</label>
              <input type="time" class="form-control" id="default_shift_duration"
                     v-model="default_shift_duration" required>
            </div>
          </fieldset>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">Cancel</button>
        <button type="button" class="btn btn-primary" @click="submitForm" :disabled="isCreateButtonDisabled">Create
          event
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {checkEventCodeUnique, checkEventNameUnique} from "@/utils/mycrew_functions";


export default {
  name: 'CreateEventModal',
  props: {
    organisation: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      code: '',
      eventCodeError: '',
      name: '',
      eventNameError: '',
      date: '',
      default_shift_start_time: '08:00',
      default_shift_duration: '08:00',
    };
  },
  computed: {
    isCreateButtonDisabled() {
      return this.code === '' ||
          this.eventCodeError !== '' ||
          this.name === '' ||
          this.eventNameError !== '' ||
          this.date === '';
    }
  },
  mounted() {
    this.$refs.inputCode.focus();
  },
  methods: {
    async submitForm() {
      this.$emit('create-event', {code: this.code.trim(), name: this.name.trim(), date: this.date});
      this.$emit('close');
    },
    handleEnterKey() {
      if (!this.isCreateButtonDisabled) {
        this.submitForm();
      }
    },
  },
  watch: {
    async code(newEventCode) {
      if (newEventCode) {
        const result = await checkEventCodeUnique(this.organisation.slug, newEventCode.trim());
        if (result.status === 'unique') {
          this.eventCodeError = '';
        } else {
          this.eventCodeError = 'Event code is not unique for this organisation';
        }
      } else {
        this.eventCodeError = '';
      }
    },
    async name(newEventName) {
      if (newEventName) {
        const result = await checkEventNameUnique(this.organisation.slug, newEventName.trim());
        if (result.status === 'unique') {
          this.eventNameError = '';
        } else {
          this.eventNameError = 'Event name is not unique for this organisation';
        }
      } else {
        this.eventNameError = '';
      }
    }
  },
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>